//@vendor
const React = require('react');
//@core
const { FormattedText } = require('core/i18n').i18n;

const LoanCollectiveTooltip = () => {
    return (
        <ul>
            <li><FormattedText value="payrollLoanRequest-collectiveMarkOneItem" /></li>
            <li><FormattedText value="payrollLoanRequest-collectiveMarkTwoItem" /></li>
            <li><FormattedText value="payrollLoanRequest-collectiveMarkThreeItem" /></li>
        </ul>
    );
};

module.exports = LoanCollectiveTooltip;
